import { TemplateData } from './htmlTemplates';

export const handwrittenCasualTemplate = {
  id: 'handwritten-casual',
  name: '手写随性',
  description: '手写风格，适合个人日记和随性内容',
  category: 'personal',
  generate: (data: TemplateData) => `
    <!DOCTYPE html>
    <html lang="zh-CN">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Cover</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .cover {
          width: 400px;
          height: 600px;
          background: #fefefe;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 50px;
          font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', cursive;
          position: relative;
          overflow: hidden;
          background-image: 
            linear-gradient(90deg, #f0f0f0 1px, transparent 1px),
            linear-gradient(#f0f0f0 1px, transparent 1px);
          background-size: 20px 20px;
        }

        .paper-texture {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: 
            radial-gradient(circle at 20% 30%, rgba(200, 200, 200, 0.1) 1px, transparent 1px),
            radial-gradient(circle at 80% 70%, rgba(200, 200, 200, 0.1) 1px, transparent 1px),
            radial-gradient(circle at 40% 80%, rgba(200, 200, 200, 0.1) 1px, transparent 1px);
          background-size: 50px 50px, 30px 30px, 40px 40px;
        }

        .brand-handwritten {
          position: absolute;
          top: 40px;
          right: 40px;
          font-size: 16px;
          color: ${data.theme.primaryColor};
          font-weight: normal;
          z-index: 2;
          transform: rotate(-5deg);
        }

        .title {
          font-size: 36px;
          font-weight: 400;
          color: #2c3e50;
          text-align: center;
          line-height: 1.4;
          margin-bottom: 40px;
          letter-spacing: 1px;
          position: relative;
          z-index: 2;
          transform: rotate(-1deg);
        }

        .title-handwritten {
          color: ${data.theme.primaryColor};
          position: relative;
          font-weight: 600;
          transform: rotate(2deg);
          display: inline-block;
        }

        .title-handwritten::after {
          content: '';
          position: absolute;
          bottom: -5px;
          left: 0;
          right: 0;
          height: 3px;
          background: ${data.theme.accentColor};
          border-radius: 2px;
          transform: rotate(-1deg);
          opacity: 0.6;
        }

        .subtitle {
          font-size: 16px;
          color: #5d6d7e;
          text-align: center;
          line-height: 1.8;
          font-weight: 300;
          position: relative;
          z-index: 2;
          max-width: 280px;
          transform: rotate(0.5deg);
        }

        .casual-highlight {
          background: ${data.theme.accentColor}40;
          color: ${data.theme.primaryColor};
          padding: 1px 4px;
          border-radius: 8px;
          font-weight: 500;
          margin: 0 1px;
          transform: rotate(-1deg);
          display: inline-block;
          border: 1px dashed ${data.theme.primaryColor}60;
        }

        .doodle-heart {
          position: absolute;
          top: 120px;
          left: 60px;
          width: 20px;
          height: 18px;
          transform: rotate(-15deg);
        }

        .doodle-heart::before,
        .doodle-heart::after {
          content: '';
          position: absolute;
          width: 12px;
          height: 19px;
          background: ${data.theme.accentColor}60;
          border-radius: 12px 12px 0 0;
          transform: rotate(-45deg);
          transform-origin: 0 100%;
        }

        .doodle-heart::after {
          left: 8px;
          transform: rotate(45deg);
          transform-origin: 0 100%;
        }

        .doodle-star {
          position: absolute;
          bottom: 150px;
          right: 70px;
          width: 0;
          height: 0;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-bottom: 12px solid ${data.theme.primaryColor}60;
          transform: rotate(35deg);
        }

        .doodle-star::before {
          content: '';
          position: absolute;
          left: -8px;
          top: 3px;
          width: 0;
          height: 0;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-top: 12px solid ${data.theme.primaryColor}60;
        }

        .scribble-line {
          position: absolute;
          top: 200px;
          left: 40px;
          width: 80px;
          height: 2px;
          background: ${data.theme.primaryColor}40;
          border-radius: 2px;
          transform: rotate(-5deg);
        }

        .scribble-line::before {
          content: '';
          position: absolute;
          top: 10px;
          left: 20px;
          width: 40px;
          height: 2px;
          background: ${data.theme.accentColor}40;
          border-radius: 2px;
          transform: rotate(10deg);
        }

        .margin-line {
          position: absolute;
          left: 40px;
          top: 0;
          bottom: 0;
          width: 2px;
          background: #ff6b6b40;
          opacity: 0.3;
        }

        .coffee-stain {
          position: absolute;
          bottom: 100px;
          left: 80px;
          width: 30px;
          height: 30px;
          background: radial-gradient(circle, rgba(139, 69, 19, 0.2) 0%, transparent 70%);
          border-radius: 50%;
          transform: rotate(20deg);
        }

        .coffee-stain::before {
          content: '';
          position: absolute;
          top: 5px;
          left: 8px;
          width: 15px;
          height: 15px;
          background: radial-gradient(circle, rgba(139, 69, 19, 0.1) 0%, transparent 70%);
          border-radius: 50%;
        }

        .signature {
          position: absolute;
          bottom: 60px;
          right: 60px;
          font-size: 12px;
          color: ${data.theme.primaryColor}80;
          transform: rotate(-10deg);
          font-style: italic;
        }
      </style>
    </head>
    <body>
      <div class="cover">
        <div class="paper-texture"></div>
        <div class="margin-line"></div>
        <div class="brand-handwritten">${data.theme.logo}</div>
        
        <div class="doodle-heart"></div>
        <div class="doodle-star"></div>
        <div class="scribble-line"></div>
        <div class="coffee-stain"></div>
        
        <h1 class="title">
          ${data.title.split(' ').map((word, i) => 
            i === 1 ? `<span class="title-handwritten">${word}</span>` : word
          ).join(' ')}
        </h1>
        <p class="subtitle">${data.subtitle.replace(/([^\s]{2,4})/g, '<span class="casual-highlight">$1</span>')}</p>
        
        <div class="signature">~ 记录生活 ~</div>
      </div>
    </body>
    </html>
  `
};
